import React from "react";
// import Logo from "./logo";
import logo from './assets/Alliance_Logo_REV.svg';
import Awards from "./Awards";
import {
  Badge,
  Box,
  Button,
  Center,
  Container,
  Flex,
  Heading,
  Link,
  Spacer,
  useColorMode,
  // useColorModeValue,
} from "@chakra-ui/react";
import { ExternalLinkIcon, MoonIcon, SunIcon } from "@chakra-ui/icons";

import Placeholder from "./Placeholder";
import { programYear, isAnnounced, announceDate } from './constants';
const today = Date.now()

function Header() {
  const { colorMode, toggleColorMode } = useColorMode();

  return (
    <Flex wrap="wrap" justify="space-around" pt={10}>
      <img src={logo} alt="Alliance for Young Artists and Writers" style={{ width: '70%', maxWidth: '500px' }} />
      <Button position="absolute" right="35px" onClick={toggleColorMode}>
        {colorMode === "light" ? <MoonIcon /> : <SunIcon />}
      </Button>
    </Flex>
  );
}

export default function App() {
  const devURLs = [
    "https://medals-stage.artandwriting.org/",
    "https://seb3000.artandwriting.org/",
    "http://localhost:3000/",
  ];

  const stage = devURLs.includes(window.location.href) ? (
    <Center >
        <Badge alignfontSize='0.8em' colorScheme='red'>
          Test & Stage: {window.location.href}
        </Badge>
    </Center>
  ) : null;

  return (
    <Container maxWidth={{ base: "100%", sm: "90%", md: "85%" }}>
      {stage}
      <Flex direction="column" minHeight="100vh">
        <Header />

        {isAnnounced && (
          <Center mt={35} mb={2}>
            <Heading as="h2" size="sm">
              Students and Educators: Please
              <Link
                color="teal"
                href="https://portal.artandwriting.org"
                isExternal
              >
                {" "}
                log into your account <ExternalLinkIcon mx="2px" />
              </Link>{" "}
              to review required next steps to accept your award(s).
            </Heading>
          </Center>
        )}

        <Box flex="1">
          {today < announceDate ? <Placeholder /> : <Awards />}
          {/* <Awards /> */}
        </Box>
        <Spacer />

        <Center p={8}>
          <Link href="https://artandwriting.org" isExternal>
            © {programYear} Alliance for Young Artists & Writers, New York, NY
          </Link>
        </Center>
      </Flex>
    </Container>
  );
}
